/* eslint-disable @typescript-eslint/no-explicit-any */
import MiniOrchService from '~packages/miniorch-service/src/utils/MiniOrchService';

import { useMiniOrchService } from '@/shared/composables';
import { useLoading } from '@/shared/lib';

/**
 *
 */
export enum EErrMsg {
  INIT_RESULT_TRUE = 'INIT_RESULT_TRUE',
  MINIORCH_RESULT_STATUS_FALSE = 'MINIORCH_RESULT_STATUS_FALSE',
  UNKNOWN = 'UNKNOWN',
  URL_EMPTY = 'URL_EMPTY',
}

/**
 *
 */
export type Format = 'pdf' | 'xlsx';

/**
 *
 */
export interface ICfg {
  notifyError?: NotifyError;
  notifySuccess?: NotifySuccess;
}
/**
 *
 */
export type NotifyError = (m: string) => void;
export type NotifySuccess = (m: string) => void;

/**
 *
 */
export default abstract class PrintService {
  isInited: boolean;
  miniOrchService: MiniOrchService;
  msgDefault: string;
  notifyError?: NotifyError;
  notifySuccess?: NotifySuccess;
  setIsLoading: (val: boolean, delay?: number) => void;

  /**
   *
   * @param cfg
   */
  constructor({ notifyError, notifySuccess }: ICfg) {
    this.isInited = false;
    this.msgDefault = 'Не удалось скачать файл';

    this.notifyError = notifyError;
    this.notifySuccess = notifySuccess;

    this.miniOrchService = useMiniOrchService();
    this.setIsLoading = useLoading().setIsLoading;
  }

  /**
   *
   * @param url
   * @returns
   */
  async blobFetchFromUrl(url: string) {
    await this.miniOrchService.authenticate();
    return await this.miniOrchService.blobFetchFromUrl(url);
  }

  /**
   *
   * @param code
   * @param info
   * @param msg
   */
  errorShow(code: keyof typeof EErrMsg, info?: any, msg?: string) {
    this.notifyError?.(`Ошибка! ${msg ?? (EErrMsg[code] || this.msgDefault)}`);
    this.warn(this.constructor.name, code, info);
  }

  /**
   *
   * @param format
   * @returns
   */
  fileNameNew(format: Format) {
    return `file.${format}`;
  }

  /**
   *
   * @returns
   */
  async init() {
    this.isInited = true;
    return false;
  }

  /**
   *
   * @param format
   * @param isLatest
   * @returns
   */
  async print(
    format: Format = 'pdf',
    fileName?: string,
    isLatest?: boolean,
    mode: string,
    ntReturnData?: boolean,
    ntDownload?: boolean
  ) {
    this.setIsLoading(true);

    /* Mock for checks */
    let needToStop = false;
    // needToStop = true;
    needToStop = false;

    if (needToStop) {
      this.setIsLoading(false);
      return;
    }

    /*  */
    try {
      /*  */
      if (!this.isInited) {
        const needToStop = await this.init();
        if (needToStop) {
          this.errorShow('INIT_RESULT_TRUE');
          this.setIsLoading(false);
          return;
        }
      }

      /*  */
      if (this.printCheckCancel()) return;

      /*  */
      console.log(135, { format, mode, isLatest });
      const data = await this.urlNew(format, isLatest, mode);
      console.log('data from urlNew:', data);
      if (!data) {
        this.errorShow('URL_EMPTY');
        this.setIsLoading(false);
        return;
      }

      /*  */
      if (ntDownload) await this.printPure(data, fileName, format);
      return ntReturnData ? data : true;
    } catch (err) {
      this.errorShow('UNKNOWN', err instanceof Error ? err.message : err);
    } finally {
      this.setIsLoading(false);
    }
  }

  /**
   *
   * @returns
   */
  printCheckCancel() {
    return false;
  }

  /**
   *
   * @param url
   * @param format
   * @returns
   */
  async printPure(url: string, fileName?: string, format: Format = 'pdf') {
    await this.miniOrchService.authenticate();

    const result = await this.miniOrchService.downloadFromUrl(
      url,
      fileName ?? this.fileNameNew(format),
      undefined,
      false
    );
    console.log('result', result);
    if (!result.status) {
      this.errorShow('MINIORCH_RESULT_STATUS_FALSE');
      this.setIsLoading(false);
      return;
    }

    this.notifySuccess?.('Успешно! Файл скачан.');
  }

  /**
   *
   * @param format
   * @param isLatest
   */
  abstract urlNew(
    format?: string,
    isLatest?: boolean,
    mode?: string
  ): Promise<string | undefined>;

  /**
   *
   * @param args
   */
  warn(...args: any[]) {
    console.warn(...args);
  }
}
